<div
  class="early-access-container horizontal-center back-btn"
  (keydown)="handleKeydown($event)"
  (click)="disabled($event)"
>
  <div class="early-access-modal">
    <h2
      [innerHTML]="'upgrade_now' | translate"
      [style]="'fontSize.36' | translate"
    ></h2>
    <p
      [innerHTML]="'upgrade_now_desc' | translate"
      [style]="'fontSize.28' | translate"
    ></p>
    <div
      class="actions horizontal-as horizontal-focusable-container generic-dialog"
    >
      <app-icon-button
        [label]="'learn_how' | translate"
        class="learn-how-button"
        (clicked)="learnHowAction()"
      ></app-icon-button>
      <app-icon-button
        [label]="'global.cancel' | translate"
        (clicked)="cancelAction()"
      ></app-icon-button>
    </div>
  </div>
</div>
